const logotext = "MH Mahim";
const meta = {
  title: "Mahim",
  description: "I’m MD. Monir Hossen Mahim Front End Devloper",
};

const introdata = {
  title: "I’m MD. Monir Hossen Mahim",
  animated: {
    first: "I love to code",
    second: "I build cool websites",
    third: "I develop web application",
  },
  description: "I’m Front End Devloper",
  your_img_url: "./IMG-20230201-WA0006.jpg",
};

const dataabout = {
  title: "About My Self",
  aboutme:
    "I’m MD. Monir Hossen Mahim. I live in Dhaka and my hometown is madaripur. I enjoy web development and have created 6 to 10 frontend and backend projects using  HTML, CSS, Javascript, Nodejs, Expressjs ,MongoDB , reactjs, react-router-v6, and react-redux. My ambition is to become a full-stack developer, with a focus on the mern and python stacks.",
};
const worktimeline = [
  {
    jobtitle: "C & C++ Instructor",
    where: "Tejgaon College Programming Club",
    date: "01/2022 - 09/2023",
  },
  {
    jobtitle: "Vice President",
    where: "Tejgaon College Programming Club",
    date: "10/2023 - 10/2024",
  },
  {
    jobtitle: "Frontend Developer",
    where: "Softvence",
    date: "12/2024 - present",
  },
];

const skills = [
  {
    name: "Html",
    value: 80,
  },
  {
    name: "Css",
    value: 60,
  },
  {
    name: "Javascript",
    value: 70,
  },
  {
    name: "C & C++",
    value: 80,
  },
  {
    name: "PHP",
    value: 50,
  },
  {
    name: "TailwindCss",
    value: 75,
  },
  {
    name: "Bootstrap",
    value: 60,
  },
  {
    name: "React",
    value: 75,
  },
  {
    name: "React-router-v6",
    value: 80,
  },
  {
    name: "React-Redux",
    value: 65,
  },
  {
    name: "Node",
    value: 60,
  },
  {
    name: "Express",
    value: 70,
  },
  {
    name: "MongoDB",
    value: 75,
  },
];

const services = [
  {
    title: "Web Design",
    description:
      "Skilled in modern web design principles, creating responsive, visually appealing, and user-centered websites. Proficient in HTML, CSS, and JavaScript frameworks to enhance user experience and functionality.",
  },
  {
    title: "Frontend Development",
    description:
      "Experienced in front-end development, specializing in building dynamic, responsive interfaces with Tailwind CSS, and ReactJS. Proficient in React and modern frameworks to deliver seamless user experiences and optimized performance.",
  },
  {
    title: "Backend Development",
    description:
      "Proficient in backend development using the MERN stack, with expertise in building scalable APIs and robust server-side applications. Skilled in MongoDB, Express, and Node.js to design and manage databases, authentication, and server logic efficiently.",
  },
];

const dataportfolio = [
  {
    img: "https://i.ibb.co.com/ch79W02N/goldlync-com-constructor-profile-add-project.jpg",
    desctiption:
      "Developed GoldLync, a services marketplace platform that connects customers with trusted professionals for home improvement, repairs, and personal services—all in one place.",
    livelink: "https://goldlync.com/",
  },
  {
    img: "https://i.ibb.co.com/1JQqByFc/screencapture-lenaraman-netlify-app-2026-01-29-18-03-03-1.png",
    desctiption:
      "Created AutoChatAI - an AI-powered chat platform designed to deliver real-time, intelligent conversations through a clean and user-friendly interface.",
    livelink: "https://lenaraman.netlify.app/",
  },
  {
    img: "https://i.ibb.co.com/hJMhz18n/screencapture-marion-frontend-netlify-app-2026-01-29-18-00-34-1.png",
    desctiption:
      "Built Marion, a responsive e-commerce frontend showcasing furniture and home decor collections with intuitive browsing, product highlights, and a visually engaging shopping experience.",
    livelink: "https://marion-frontend.netlify.app/",
  },
  {
    img: "https://i.ibb.co.com/xSjjrG9M/screencapture-losupremomusic-2026-01-29-17-41-06-1.png",
    desctiption:
      "Built LosupremoMusic, an online music platform focused on sharing original tracks and creative releases, delivering a clean and engaging experience for discovering fresh sounds.",
    livelink: "https://losupremomusic.com/",
  },
  {
    img: "https://i.ibb.co.com/JRtQByhV/screencapture-saalah-netlify-app-2026-01-29-17-57-15-1.png",
    desctiption:
      "Developed Saalah, a travel booking platform that lets users search routes, view available trips, and book shared journeys with transparent pricing and seamless experience.",
    livelink: "https://saalah.netlify.app/",
  },
  {
    img: "https://i.ibb.co.com/PZQ0jDP9/screencapture-starat-backend-netlify-app-story-3-0-2025-12-27-22-04-57.png",
    desctiption:
      "Developed Starat, a feature-rich social media platform with real-time chat, multi-theme support, and a modern, scalable user experience.",
    livelink: "https://starat.netlify.app/",
  },
  {
    img: "https://i.ibb.co.com/qFXT2FP7/duelert-frontend-netlify-app-2-1.jpg",
    desctiption:
      "Created Duelert, a smart reminder platform that helps businesses stay connected by automating customer birthdays, anniversaries, and events with personalized messages and flexible plans.",
    livelink: "https://duelert-frontend.netlify.app/",
  },
  {
    img: "https://i.ibb.co.com/GGqS9Ft/one-heart-society-netlify-app.jpg",
    desctiption:
      "Built a compassionate community platform for One Heart Society, featuring private requests, supporter contributions, and emotional sanctuary spaces for those in need.",
    livelink: "https://one-heart-society.netlify.app/",
  },
  {
    img: "https://i.ibb.co.com/xkVvg8n/things-to-do-liists-netlify-app.jpg",
    desctiption:
      "ThingsToDoLists - a travel and experiences platform curating the best tours, events, and activities worldwide with instant booking, lowest prices, and 24/7 support.",
    livelink: "https://things-to-do-liists.netlify.app/",
  },
  {
    img: "https://i.ibb.co.com/x8CcHwK8/localhost-5173.jpg",
    desctiption:
      "Developed a dynamic gaming services website for Vanguard Boost with secure payments, service catalog, offers, reviews, FAQs, and 24/7 customer support.",
    livelink: "https://vanguard-bost.netlify.app/",
  },
  {
    img: "https://i.ibb.co.com/dwTfvJZN/screencapture-stelk-netlify-app-2025-09-05-21-08-11-1.jpg",
    desctiption:
      "Developed a responsive marketing landing page for LeadTalk to showcase features, demo, and FAQs, helping businesses automate lead targeting and boost sales.",
    livelink: "https://stelk.netlify.app/",
  },
  {
    img: "https://i.ibb.co.com/Z6qd6g65/coleridgeadvisors-net-1.png",
    desctiption:
      "A professional website for a consulting firm, showcasing services, team, and client testimonials with a clean, modern design.",
    livelink: "https://coleridgeadvisors.net/", // https://aleksandraa.netlify.app/
  },
  {
    img: "https://i.ibb.co.com/nqnwq7DH/project1.png",
    // img: "https://i.ibb.co.com/k0X60rn/project1.png",
    desctiption:
      "Built an agency web app for streamlined client management, project tracking, and team collaboration with a responsive, user-friendly design.",
    livelink: "https://oribo.netlify.app/",
    codelink: "https://github.com/mahimerror/oribo",
  },
  {
    img: "https://i.ibb.co.com/pBbv9WjD/project2.png",
    // img: "https://i.ibb.co.com/P4h1ftk/project2.png",
    desctiption:
      "Created a cryptography algorithm library with easy-to-integrate encryption and decryption tools for enhanced data security.",
    livelink: "https://crypto-graaphy.netlify.app/tc",
    codelink: "https://github.com/mahimerror/crypto-graphy",
  },
  {
    img: "https://i.ibb.co.com/KzQcc0y8/project3.png",
    // img: "https://i.ibb.co.com/3BkcyDD/project3.png",
    desctiption:
      "Developed a dynamic news portal web app with real-time updates, category filtering, and an intuitive, responsive design for seamless user engagement.",
    livelink: "https://dragon-newss.netlify.app/",
    codelink: "https://github.com/mahimerror/dragon-news",
  },

  {
    img: "https://i.ibb.co.com/jvMYwmWD/project4.png",
    // img: "https://i.ibb.co.com/hHmMQwT/project4.png",
    desctiption:
      "Designed a responsive e-commerce web frontend, focusing on user-friendly navigation, product displays, and a streamlined checkout process to enhance customer experience.",
    livelink: "https://mahimerror.github.io/penguin-fashion/",
    codelink: "https://github.com/mahimerror/penguin-fashion",
  },
  {
    img: "https://i.ibb.co.com/Cp7c2NQ7/project5.png",
    // img: "https://i.ibb.co.com/dtnRbCc/project5.png",
    desctiption:
      "Crafted a responsive frontend for a book-review web app, featuring intuitive navigation, interactive review sections, and personalized book recommendations to engage readers.",
    link: "",
    livelink: "https://book-reviiew.netlify.app/",
    codelink: "https://github.com/mahimerror/book-review",
  },
  {
    img: "https://i.ibb.co.com/pjMM4Wcp/restuurant-netlify-app-3.png",
    desctiption:
      "Create a restaurant website landing page with responsive design, menu showcase, and reservation features using HTML, CSS, and JavaScript.",
    link: "",
    livelink: "https://restuurant.netlify.app/",
    codelink: "https://github.com/mahimerror/restaurant",
  },
  {
    img: "https://i.ibb.co.com/kgmbw8Vd/agroo-tech-netlify-app-1.png",
    desctiption:
      "Developed a comprehensive agro-tech web application with features for crop management, market analysis, and farmer resources, utilizing a user-friendly interface.",
    link: "",
    livelink: "https://agroo-tech.netlify.app/",
    codelink: "https://github.com/mahimerror/agro-tech",
  },
];

const contactConfig = {
  YOUR_EMAIL: "mahimislam46@gmail.com",
  YOUR_FONE: "+880-1733-783956",
  description: "You can contact with me this email and phone number",
  // creat an emailjs.com account
  // check out this tutorial https://www.emailjs.com/docs/examples/reactjs/
  YOUR_SERVICE_ID: "service_x4otutk",
  YOUR_TEMPLATE_ID: "template_e8jlhcf",
  YOUR_USER_ID: "xu5SG_f2ynxQWcBR6",
};

const socialprofiles = {
  github: "https://github.com/mahimerror",
  facebook: "https://facebook.com/mahim.error/",
  linkedin: "https://linkedin.com/in/mh-mahim/",
};

export {
  meta,
  dataabout,
  dataportfolio,
  worktimeline,
  skills,
  services,
  introdata,
  contactConfig,
  socialprofiles,
  logotext,
};
